import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getCountriesList } from '../../../Domain/Redux/Actions/Actions/ActionCountriesList';
import { useGetIdLanguage } from '../HookLanguageSelector/useGetIdLnaguage';

export function useCountries() {
  const dispatch = useDispatch();
  const language = useGetIdLanguage();
  const { countriesList, alpha2codeCountries, phoneTypeList, lastLanguage } = useSelector(
    (state) => state.countriesList
  );

  useEffect(() => {
    if (!language || lastLanguage === language) return;

    (async () => {
      const action = await getCountriesList(language);
      if (action) {
        dispatch(action);
      }
    })();
  }, [language, dispatch, lastLanguage]);

  return { countriesList, alpha2codeCountries, phoneTypeList };
}
